import gql from "graphql-tag";

export default gql`
  fragment attendancePlaceParts on AttendancePlace {
    id
    name
    parent {
      id
      name
    }
  }
`;
